import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_108_employee: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "122",
      action: "modulev1/emp_add",
    },
    title: "Employees",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "txt_name",
            Name: "emp_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/emp_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "122",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "emp_summary",
                },
                ActionType: "Delete",
                ScreenId: "19",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "employee_details",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "emp_summary",
              TableName: "employee",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Name",
                  BindValue: "txt_name",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Mobile",
                  BindValue: "txt_mobile",
                  Json_Attribute: "mobile",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Group",
                  IsMandatory: true,
                  BindValue: "drp_group",
                  Json_Attribute: "group_id",
                  componentType: ComponentType.SELECT_DROPDOWN,
                  showInSummary: true,
                  LookupName: "employee_group",   
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
